import { HTML_LINK_TARGET } from '../../../constants/html'
import { Link } from '../../Link'
import { PageEmptyState } from '../../PageEmptyState'
import { Container } from '../Container'

import {
  PAGE_EMPTY_STATES_AUTOMATE_PROCESS_ACTIONS,
  PAGE_EMPTY_STATES_BUILDINGS_ACTIONS,
  PAGE_EMPTY_STATES_BUILDINGS_GROUPS_ACTIONS,
  PAGE_EMPTY_STATES_CHATS_ACTIONS,
  PAGE_EMPTY_STATES_CUSTOMERS_ACTIONS,
  PAGE_EMPTY_STATES_DOCUMENT_SPLITTING_ACTIONS,
  PAGE_EMPTY_STATES_DOCUMENTS_ACTIONS,
  PAGE_EMPTY_STATES_EMAIL_INTEGRATIONS_ACTIONS,
  PAGE_EMPTY_STATES_EMAILS_ACTIONS,
  PAGE_EMPTY_STATES_EXTERNAL_CONTACTS_ACTIONS,
  PAGE_EMPTY_STATES_FLATS_ACTIONS,
  PAGE_EMPTY_STATES_INSURANCES_ACTIONS,
  PAGE_EMPTY_STATES_INVOICES_ACTIONS,
  PAGE_EMPTY_STATES_POSTS_ACTIONS,
  PAGE_EMPTY_STATES_PROVIDERS_ACTIONS,
  PAGE_EMPTY_STATES_RATING_ACTIONS,
  PAGE_EMPTY_STATES_REQUESTS_ACTIONS,
  PAGE_EMPTY_STATES_TASKS_ACTIONS,
  PAGE_EMPTY_STATES_USER_DATA_ACTIONS,
  PAGE_EMPTY_STATES_USERS_ACTIONS,
} from './PageEmptyStates.constants'

import * as styles from './PageEmptyStates.module.css'

import AutomateProcessIcon from '../../../icons/automate-processes.svg'
import BuildingsIcon from '../../../icons/building.svg'
import BuildingsGroupIcon from '../../../icons/buildings-group.svg'
import MessageIcon from '../../../icons/chats.svg'
import ContractIcon from '../../../icons/contract.svg'
import DocIcon from '../../../icons/doc.svg'
import DocSplittingIcon from '../../../icons/doc-splitting.svg'
import DocumentIcon from '../../../icons/document.svg'
import EmailIcon from '../../../icons/email.svg'
import FlatsIcon from '../../../icons/flat.svg'
import ImportUserDataIcon from '../../../icons/import-user-data.svg'
import InsuranceIcon from '../../../icons/insurance.svg'
import InvoiceIcon from '../../../icons/invoice.svg'
import NotificationIcon from '../../../icons/notification.svg'
import OffersIcon from '../../../icons/offers.svg'
import OrderIcon from '../../../icons/orders.svg'
import ContactIcon from '../../../icons/phone.svg'
import PostIcon from '../../../icons/post.svg'
import ProvidersIcon from '../../../icons/providers.svg'
import SearchIcon from '../../../icons/search.svg'
import ServiceRequestIcon from '../../../icons/service-request.svg'
import RatingIcon from '../../../icons/star.svg'
import TaskIcon from '../../../icons/task.svg'
import UserIcon from '../../../icons/user.svg'
import UsersIcon from '../../../icons/users-1.svg'

function PageEmptyStates() {
  return (
    <>
      <Container label='Page empty state, emails'>
        <PageEmptyState
          EntityIcon={EmailIcon}
          actions={PAGE_EMPTY_STATES_EMAILS_ACTIONS}
          text='Please, go to Settings and connect your e-mail account (e.g. Outlook or Gmail) with this workspace in only a few steps.'
        />
      </Container>
      <Container label='Page empty state, service requests'>
        <PageEmptyState
          EntityIcon={ServiceRequestIcon}
          actions={PAGE_EMPTY_STATES_REQUESTS_ACTIONS}
          text='No service request available.'
        />
      </Container>
      <Container label='Page empty state, buildings'>
        <PageEmptyState
          EntityIcon={BuildingsIcon}
          actions={PAGE_EMPTY_STATES_BUILDINGS_ACTIONS}
          text='No building was set up yet. Set up you four building.'
        />
      </Container>
      <Container label='Page empty state, chats'>
        <PageEmptyState
          EntityIcon={MessageIcon}
          actions={PAGE_EMPTY_STATES_CHATS_ACTIONS}
          text='No chat available.'
        />
      </Container>
      <Container label='Page empty state, providers'>
        <PageEmptyState
          EntityIcon={ProvidersIcon}
          actions={PAGE_EMPTY_STATES_PROVIDERS_ACTIONS}
          text='No providers avaliable.'
        />
      </Container>
      <Container label='Page empty state, flats'>
        <PageEmptyState
          EntityIcon={FlatsIcon}
          actions={PAGE_EMPTY_STATES_FLATS_ACTIONS}
          text='No flats avaliable.'
        />
      </Container>
      <Container label='Page empty state, documents'>
        <PageEmptyState
          EntityIcon={DocIcon}
          actions={PAGE_EMPTY_STATES_DOCUMENTS_ACTIONS}
          text='No documents avaliable.'
        />
      </Container>
      <Container label='Page empty state, tasks'>
        <PageEmptyState
          EntityIcon={TaskIcon}
          actions={PAGE_EMPTY_STATES_TASKS_ACTIONS}
          text='No task avaliable.'
        />
      </Container>
      <Container label='Page empty state, users'>
        <PageEmptyState
          EntityIcon={UsersIcon}
          actions={PAGE_EMPTY_STATES_USERS_ACTIONS}
          text='No user avaliable.'
        />
      </Container>
      <Container label='Page empty state, offers'>
        <PageEmptyState EntityIcon={OffersIcon} text='No offers avaliable.' />
      </Container>
      <Container label='Page empty state, orders'>
        <PageEmptyState EntityIcon={OrderIcon} text='No orders avaliable.' />
      </Container>
      <Container label='Page empty state, posts'>
        <PageEmptyState
          EntityIcon={PostIcon}
          actions={PAGE_EMPTY_STATES_POSTS_ACTIONS}
          text='No posts avaliable.'
        />
      </Container>
      <Container label='Page empty state, invoices'>
        <PageEmptyState
          EntityIcon={InvoiceIcon}
          actions={PAGE_EMPTY_STATES_INVOICES_ACTIONS}
          text='No invoices avaliable.'
        />
      </Container>
      <Container label='Page empty state, change log'>
        <PageEmptyState
          EntityIcon={DocumentIcon}
          text='No change log avaliable.'
        />
      </Container>
      <Container label='Page empty state, notifications'>
        <PageEmptyState
          EntityIcon={NotificationIcon}
          text='No notifications avaliable.'
        />
      </Container>
      <Container label='Page empty state, tenants & landlords'>
        <PageEmptyState
          EntityIcon={UserIcon}
          actions={PAGE_EMPTY_STATES_CUSTOMERS_ACTIONS}
          text='No tenant & landlord avaliable.'
        />
      </Container>
      <Container label='Page empty state, contracts'>
        <PageEmptyState
          EntityIcon={ContractIcon}
          text='No contracts avaliable.'
        />
      </Container>
      <Container label='Page empty state, insurances'>
        <PageEmptyState
          EntityIcon={InsuranceIcon}
          actions={PAGE_EMPTY_STATES_INSURANCES_ACTIONS}
          text='No insurances avaliable.'
        />
      </Container>
      <Container label='Page empty state, external contacts'>
        <PageEmptyState
          EntityIcon={ContactIcon}
          actions={PAGE_EMPTY_STATES_EXTERNAL_CONTACTS_ACTIONS}
          text='No external contacts avaliable.'
        />
      </Container>
      <Container label='Page empty state, building groups'>
        <PageEmptyState
          EntityIcon={BuildingsGroupIcon}
          actions={PAGE_EMPTY_STATES_BUILDINGS_GROUPS_ACTIONS}
          text='No groups avaliable.'
        />
      </Container>
      <Container label='Page empty state, import user data, without load url input'>
        <PageEmptyState
          EntityIcon={ImportUserDataIcon}
          actions={PAGE_EMPTY_STATES_USER_DATA_ACTIONS}
          className={styles.loadUserData}
          text={
            <>
              Easy Excel upload of all your user data via .xls or .xlsx. Please
              use this Excel sheet (
              <Link
                rel='noopener noreferrer'
                target={HTML_LINK_TARGET.blank}
                to='https://goo.gl/Jk8F3Z'
              >
                https://goo.gl/Jk8F3Z
              </Link>
              ) as an orientation for your data import. The following customer
              data is mandatory: First name, Surname, Address, Door number,
              Email address or telephone number. All other information is
              optional. The iDWELL team is happy to help if you need any
              assistance. .xls or .xlsx
            </>
          }
        />
      </Container>
      <Container label='Page empty state, email integrations'>
        <PageEmptyState
          EntityIcon={EmailIcon}
          actions={PAGE_EMPTY_STATES_EMAIL_INTEGRATIONS_ACTIONS}
          text='No email accounts avaliable.'
        />
      </Container>
      <Container label='Page empty state, automate process'>
        <PageEmptyState
          EntityIcon={AutomateProcessIcon}
          actions={PAGE_EMPTY_STATES_AUTOMATE_PROCESS_ACTIONS}
          text='No phase avaliable.'
        />
      </Container>
      <Container label='Page empty state, search results'>
        <PageEmptyState
          EntityIcon={SearchIcon}
          text='No search results available.'
        />
      </Container>
      <Container label='Page empty state, document splitting'>
        <PageEmptyState
          EntityIcon={DocSplittingIcon}
          actions={PAGE_EMPTY_STATES_DOCUMENT_SPLITTING_ACTIONS}
          text='No documents avaliable.'
        />
      </Container>
      <Container label='Page empty state, rating'>
        <PageEmptyState
          EntityIcon={RatingIcon}
          actions={PAGE_EMPTY_STATES_RATING_ACTIONS}
          text='No rating avaliable.'
        />
      </Container>
    </>
  )
}

export default PageEmptyStates
